<template>
  <div class="info-card">
    <p v-if="r7eApp.isDebugMode()">
      <strong>{{ t('account.id') }}:</strong> {{ account.id }}
    </p>
    <p v-if="account.name">
      <strong>{{ t('account.name') }}:</strong> {{ account.name }}
    </p>
    <p><strong>{{ t('account.email') }}:</strong> {{ account.email }}</p>
    <p><strong>{{ t('account.memberSince') }}:</strong> {{ account.creation_date }}</p>
    <p><strong>{{ t('account.lastLogin') }}:</strong> {{ account.last_login_date }}</p>
    <!-- <p><strong>Publisher:</strong> {{ account.is_publisher ? 'Yes' : 'No' }}</p>
      <p><strong>Consumer:</strong> {{ account.is_consumer ? 'Yes' : 'No' }}</p> -->
  </div>
    
  <!-- Add more fields as needed -->
  <div class="info-card">
    <div
      class="profile-header"
      v-if="account?.data?.profile?.avatar_url"
    >
      <img
        :src="account.data.profile.avatar_url"
        alt="Avatar"
        class="profile-avatar"
      >
    </div>
    <h3 v-else>
      {{ t('account.profile') }}
    </h3>
    <template v-if="account?.data?.profile">
      <p
        v-for="(value, key) in account.data.profile"
        :key="key"
      >
        <strong>{{ t("profile.key_" + key.toUpperCase(), key) }}: </strong> 
        <a
          v-if="key === 'home_page'"
          :href="value"
          target="_blank"
        >{{ value }}</a>
        <a
          v-else-if="key === 'linkedin'"
          :href="value"
          target="_blank"
        >{{ value }}</a>
        <a
          v-else-if="key === 'orcid'"
          :href="`https://orcid.org/my-orcid?orcid=${value}`"

          target="_blank"
        >{{ value }}</a>
        <a
          v-else-if="key === 'google_scholar'"
          :href="`https://scholar.google.com/citations?user=${value}`"
          target="_blank"
        >{{ value }}</a>
        <template v-else-if="key === 'emails'">
          <span
            v-for="(email, index) in value"
            :key="email"
          >
            <a
              :href="`mailto:${email}`"
              target="_blank"
            >{{ email }}</a> <span v-if="index < value.length - 1">, </span> 
          </span>
        </template>
        <template v-else-if="key === 'avatar_url'">
          <a
            v-if="value && value.startsWith('http')"
            :href="value"
            target="_blank"
          >{{ value }}</a>
          <span v-else>{{ value }}</span>
        </template>
        <span v-else>{{ value }}</span>
      </p>
    </template>
    <div style="margin-top: 20px;">
      <button
        class="edit-profile-btn"
        @click="editProfile"
      >
        {{ t('profileSetupView.editProfile') }}
      </button>
    </div>  
  </div>
   
  <div class="info-card">
    <p><strong>{{ t('account.services') }}:</strong> {{ accountServices.join(', ') }}</p>
  </div>
</template>
  
  <script setup>
  import { useI18n } from 'vue-i18n';
  import { defineProps, toRef } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  const router = useRouter();
  const route = useRoute();
  const { t } = useI18n();

  // eslint-disable-next-line no-unused-vars
  const props = defineProps({
      account: {
        type: Object,
        required: true
      },
      accountServices: {
        type: Array,
        required: true
      },
      r7eApp: {
        type: Object,
        required: true
      }
    });  

  const editProfile = () => {
    router.push({ path: '/profile-setup', query: { redirectTo: route.fullPath } });
  };
  
  const account = toRef(props.account);
  const accountServices = toRef(props.accountServices); 
  </script>
  
  <style scoped>
  .info-card {
    background-color: var(--color-frame-bg);
    border: 1px solid var(--color-border);
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 1rem;
  }
  .info-card p {
    margin: 10px 0;
    font-size: 1.1em;
  }
  .info-card strong {
    color: var(--color-safe);
  }
  .profile-separator {
    border-top: 1px solid var(--color-border);
    margin: 20px 0;
  }
  .profile-value {
    color: var(--color-text);
    font-style: italic;
  }
  .edit-profile-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: var(--color-safe);
    color: var(--color-text-light);
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 120ms ease, box-shadow 160ms ease, filter 160ms ease;
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  }
  .edit-profile-btn:hover {
    filter: brightness(0.96);
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  }
  .edit-profile-btn:active {
    transform: translateY(1px) scale(0.99);
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  }
  .edit-profile-btn:focus-visible {
    outline: 2px solid var(--color-border);
    outline-offset: 2px;
  }
  .edit-profile-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    filter: none;
  }
  .profile-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid var(--color-border);
    background: #f2f2f2;
    vertical-align: middle;
    float: right;
  }
  .profile-header .profile-avatar {
    float: none;
  }

  .account-container {
    /* max-width: 600px; */
    margin: 1rem auto;
    padding: 1rem;
    background: var(--color-frame-bg);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.10);
  }
  .api-key {
    font-family: monospace;
    background:var(--color-bg);
    padding: 2px 8px;
    border-radius: 4px;
    margin-right: 10px;
  }
  .api-key-item {
    margin-bottom: 10px;
    font-size: 0.9em;
    border-bottom: 1px solid var(--color-border);
  }
  .api-key-item .field {
    display: inline-block;
    /* margin-left: 10px; */
    margin-right: 10px;
    color: var(--color-text);
  }
  .api-key-item ul.details {
    display: inline-block;
    float:right;
  }
  .api-key-item .details li {
    display: inline-block;
  }
  
  .api-key-label {
    margin-right: 10px;
    font-weight: bold;
    color: var(--color-text);
  }
  .api-key-id {
    margin-right: 10px;
    font-family: monospace;
  
    color: var(--color-text);
  }
  .api-key-status {
    margin-right: 10px;
    font-weight: bold;
  }
  .api-key-created {
    color: var(--color-text);
  }
  .api-key-status-active .api-key-status {
    color: var(--color-safe);
  }
  .api-key-status-inactive .api-key-status {
    color: var(--color-danger);
  }
  .api-key-status-expired .api-key-status {
    color: var(--color-danger);
  }
  
  .api-key-expiration {
    color: var(--color-text);
  }
  .api-key-last-used {
    color: var(--color-text);
  }
  .api-key-form {
    margin-top: 30px;
  }
  .api-key-form input {
    padding: 8px;
    margin-right: 10px;
    border: 1px solid var(--color-border);
    border-radius: 4px;
  }
  .api-key-form button {
    padding: 8px 16px;
    background: var(--color-safe);
    color: var(--color-text-light);
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  .error-message {
    color: var(--color-danger);
    margin-top: 10px;
  }
  .success-message {
    color: var(--color-safe);
    margin-top: 10px;
  }
  .api-keys-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    background: var(--color-bg);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  }
  .api-keys-table th, .api-keys-table td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid var(--color-border);
  }
  .api-keys-table th {
    background: var(--color-frame-bg);
    color: var(--color-text);
    font-weight: bold;
  }
  .api-keys-table tr:last-child td {
    border-bottom: none;
  }
  .api-key-label {
    font-weight: bold;
    color: var(--color-text);
  }
  .api-key-id {
    font-family: monospace;
    color: var(--color-text);
  }
  .api-key-status {
    font-weight: bold;
  }
  .api-key-status-active .api-key-status {
    color: var(--color-safe);
  }
  .api-key-status-inactive .api-key-status,
  .api-key-status-expired .api-key-status {
    color: var(--color-danger);
  }
  .api-key-created,
  .api-key-expiration,
  .api-key-last-used {
    color: var(--color-text);
  }
  </style> 